import stylesBreakpoint from './styles.breakpoint';

export default {
  xs: `@media screen and (min-width: calc(${stylesBreakpoint.xs}))`,
  sm: `@media screen and (min-width: calc(${stylesBreakpoint.sm}))`,
  md: `@media screen and (min-width: calc(${stylesBreakpoint.md}))`,
  lg: `@media screen and (min-width: calc(${stylesBreakpoint.lg}))`,
  xl: `@media screen and (min-width: calc(${stylesBreakpoint.xl}))`,
  xxl: `@media screen and (min-width: calc(${stylesBreakpoint.xxl}))`,
  maxXs: `@media screen and (max-width: calc(${stylesBreakpoint.xs} - 1px))`,
  maxSm: `@media screen and (max-width: calc(${stylesBreakpoint.sm} - 1px))`,
  maxMd: `@media screen and (max-width: calc(${stylesBreakpoint.md} - 1px))`,
  maxLg: `@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`,
  maxXl: `@media screen and (max-width: calc(${stylesBreakpoint.xl} - 1px))`,
  maxXxl: `@media screen and (max-width: calc(${stylesBreakpoint.xxl} - 1px))`,
};
